import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import VehicleSpeedRpmCalculator from '../components/tools/VehicleSpeedRpmCalculator';

const VehicleSpeedRpmPage = () => {
  return (
    <div className="min-h-screen" data-testid="vehicle-speed-rpm-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Vehicle Speed to RPM/RPS"
        description="Convert vehicle speed (km/h or m/s) to wheel and motor/engine shaft rotational speed, in both RPM and RPS."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="vehicle-speed-rpm-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <VehicleSpeedRpmCalculator />
          <ToolGuideCta guidePath="/tools/vehicle-speed-rpm/guide" toolName="Vehicle Speed to RPM/RPS" />
        </div>
      </section>
    </div>
  );
};

export default VehicleSpeedRpmPage;
